import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <header id="inicio" className="relative h-[95vh] flex items-center justify-center text-center text-white overflow-hidden px-5" data-id="element-48">
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: `linear-gradient(rgba(45,70,40,0.55), rgba(45,70,40,0.55)), url('https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?auto=format&fit=crop&w=2000&q=80')`
    }} role="img" aria-label="Adulto mayor recibiendo cuidado profesional con calidez" data-id="element-49" />

      <div className="relative z-10 max-w-[900px]" data-id="element-50">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-[2.5rem] md:text-[3.5rem] font-serif mb-5 leading-[1.1]" data-id="element-51">
          Mucho más que una residencia.
          <br data-id="element-52" />
          Un proyecto de vida.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-[1.5rem] font-sans font-light mb-[30px] max-w-[700px] mx-auto" data-id="element-53">
          Brindamos a nuestros adultos mayores la autonomía que desean y el
          cuidado médico que necesitan, rodeados de naturaleza y afecto.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex gap-4 justify-center flex-wrap" data-id="element-54">
          <a href="#contacto" className="inline-block bg-verde-oscuro text-white px-10 py-5 rounded-md no-underline font-bold font-sans text-[1.1rem] transition-all duration-300 border-2 border-verde-oscuro hover:bg-transparent hover:text-white hover:border-white focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white/50" data-id="element-55">
            SOLICITAR ENTREVISTA
          </a>
          <a href="#porque" className="inline-block bg-transparent text-white px-10 py-5 rounded-md no-underline font-bold font-sans text-[1.1rem] transition-all duration-300 border-2 border-white hover:bg-white hover:text-verde-oscuro focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-white/50" data-id="element-56">
            CONOCER SERVICIOS
          </a>
        </motion.div>
      </div>
    </header>;
}